var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "swap-item-container" }, [
    _c("img", {
      staticClass: "close-modal",
      attrs: { src: _vm.imageUrl("close-modal.png") },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.close.apply(null, arguments)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { margin: "40vh auto" } },
      [
        _c(
          "h3",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loading,
                expression: "!loading"
              }
            ]
          },
          [
            _vm._v(
              "Are you sure you want to unsave the " +
                _vm._s(_vm.itemType) +
                "?"
            )
          ]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "loading-overlay transparent"
            },
            [_c("loader")],
            1
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "buttons-container" }, [
      _c("div", { staticClass: "wtw-container small" }, [
        _c(
          "div",
          {
            staticClass: "button pink full-width",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.confirm.apply(null, arguments)
              }
            }
          },
          [_vm._v("\n                Unsave it!\n            ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "button outline full-width",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.close.apply(null, arguments)
              }
            }
          },
          [_vm._v("Nevermind")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51dc0c56", { render: render, staticRenderFns: staticRenderFns })
  }
}